/**
 * Lab ScoreDashboard runs: type No (runner1 / horseLay), Enter → Yes (runner2 /
 * horseBack) = No + run gap. Gap comes from the active run button / rateDiff.
 */

/** Prefer explicit runNo, else rateDiff, else runButtonValue (Lab onChangeRuns). */
export function resolveRunGap(opts: {
  runNo?: number | null
  rateDiff?: number | string | null
  runButtonValue?: number | string | null
}): number {
  if (opts.runNo != null && Number.isFinite(Number(opts.runNo))) {
    return Number(opts.runNo)
  }
  if (opts.rateDiff !== '' && opts.rateDiff != null && Number.isFinite(Number(opts.rateDiff))) {
    return Number(opts.rateDiff)
  }
  const btn = Number(opts.runButtonValue || 0)
  return Number.isFinite(btn) ? btn : 0
}

/** Yes run from No run + gap (Lab runner2 = Number(run) + diff). */
export function yesRunFromNo(
  noRun: string | number,
  opts: {
    runNo?: number | null
    rateDiff?: number | string | null
    runButtonValue?: number | string | null
  },
): number {
  const no = Number(noRun)
  const base = Number.isFinite(no) ? no : 0
  return base + resolveRunGap(opts)
}

/** Lab ng-keydown / keypress: Enter applies No → Yes. */
export function shouldApplyRunsOnKey(key: string): boolean {
  return key === 'Enter'
}

/** Prefer marketId for Session-API update (same as rate / suspend paths). */
export function subMarketUpdateId(details: {
  marketId?: string | null
  _id?: string | null
}): string {
  const mid = String(details.marketId ?? '').trim()
  if (mid) return mid
  return String(details._id ?? '').trim()
}
